import React, { useState, useEffect } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { ChartLineMultiple } from '@/components/charts/LineMultiple';
import { ChartAreaLegend } from '@/components/charts/AreaLegend';
import { type TotalData, OverviewTabKeyNames } from '../../index.type';

interface NetValueChartProps {
  selectedMetrics: {
    netValue?: boolean;
    [key: string]: boolean | undefined;
  };
  chartType: string;
  onUpdateChartType: (type: string) => void;
  selectChange: (key: string, checked: boolean) => void;
  timeRange?: string;
  onTimeRangeChange?: (range: string) => void;
  totalData: Pick<TotalData, OverviewTabKeyNames>;
}

const NetValueChart: React.FC<NetValueChartProps> = ({
  selectedMetrics,
  chartType,
  onUpdateChartType,
  selectChange,
  timeRange = '近1年',
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    netValue?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  const [currentTimeRange, setCurrentTimeRange] = useState(timeRange);

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  const handleCheckboxChange = (checked: boolean) => {
    selectChange('netValue', checked);
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      netValue: checked
    }));
  };

  const handleValueChange = (value: string) => {
    console.log(value, 'value');
    setCurrentTimeRange(value);
  };

  return (
    <div className="border border-[#F0F0F0] rounded-lg p-3">
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={currentSelectedMetrics.netValue || false}
            onChange={e => handleCheckboxChange(e.target.checked)}
            className="w-4 h-4"
          />
          <span className="text-base font-semibold text-[#1F1F1F]">账户净值表现</span>
        </div>
        <div className="flex items-center gap-2">
          <Select onValueChange={handleValueChange} value={currentTimeRange}>
            <SelectTrigger className="w-auto h-auto p-0 border-0 bg-transparent shadow-none focus:ring-0 focus:ring-offset-0">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-white border-gray-200 shadow-md">
              <SelectItem value="近1月">近1月</SelectItem>
              <SelectItem value="近3月">近3月</SelectItem>
              <SelectItem value="近半年">近半年</SelectItem>
              <SelectItem value="近1年">近1年</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* 图表类型切换 */}
      <Tabs value={chartType} onValueChange={onUpdateChartType} className="mb-3 text-left">
        <TabsList className="bg-[#F5F5F5] h-8 p-0.5">
          <TabsTrigger
            value="amount"
            className="px-2 py-1 text-xs data-[state=active]:bg-white data-[state=active]:text-[#000000] data-[state=inactive]:text-[#8C8C8C]"
          >
            收益金额曲线
          </TabsTrigger>
          <TabsTrigger
            value="rate"
            className="px-2 py-1 text-xs data-[state=active]:bg-white data-[state=active]:text-[#000000] data-[state=inactive]:text-[#8C8C8C]"
          >
            收益率曲线
          </TabsTrigger>
        </TabsList>
      </Tabs>

      {chartType === 'amount' && (
        <div>
          <ChartLineMultiple />
        </div>
      )}
      {chartType === 'rate' && <ChartAreaLegend />}
    </div>
  );
};

export default NetValueChart;
